import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsDark, toggleTheme as toggleThemeAction } from '../redux/features/platformSlice';

// ─── Dark theme ────────────────────────────────────────────────────────────────
export const darkTheme = {
  bg:      '#0a0e1a',
  surface: '#0d1220',
  card:    '#111827',
  card2:   '#162033',
  border:  '#1e2d47',
  borderL: '#243657',

  primary:     '#2563eb',
  primaryL:    '#3b82f6',
  primaryGlow: 'rgba(37,99,235,0.14)',

  pos:   '#10b981',
  posL:  '#34d399',
  posBg: 'rgba(16,185,129,0.09)',
  neg:   '#ef4444',
  negL:  '#f87171',
  negBg: 'rgba(239,68,68,0.09)',

  orange:   '#f59e0b',
  orangeBg: 'rgba(245,158,11,0.1)',

  text:  '#f1f5f9',
  textS: '#94a3b8',
  textM: '#4b5a72',

  chartBg:   '#0a0e1a',
  buyCandle: '#388ee3',
  selCandle: '#eb434e',
  marklineBuy:  '#388ee3',
  marklineSell: '#eb434e',
  marklineOpen: '#aaaaaa',
  marklineSL:   '#E55604',
  marklineTP:   '#bb86fc',
  axisLabel:    '#888899',
  splitLine:    '#1e2d47',
  lineChart:    '#388ee3',
  lineChartA1:  'rgba(56,142,227,0.20)',
  lineChartA2:  'rgba(56,142,227,0)',

  sans: "'DM Sans','Segoe UI',sans-serif",
  mono: "'JetBrains Mono','Fira Code','Consolas',monospace",
};

// ─── Light theme ───────────────────────────────────────────────────────────────
export const lightTheme = {
  bg:      '#f4f6f9',
  surface: '#ffffff',
  card:    '#ffffff',
  card2:   '#f0f2f6',
  border:  '#dfe3ea',
  borderL: '#cdd3de',

  primary:     '#2563eb',
  primaryL:    '#3b82f6',
  primaryGlow: 'rgba(37,99,235,0.08)',

  pos:   '#16a34a',
  posL:  '#22c55e',
  posBg: 'rgba(22,163,74,0.07)',
  neg:   '#dc2626',
  negL:  '#ef4444',
  negBg: 'rgba(220,38,38,0.07)',

  orange:   '#ea580c',
  orangeBg: 'rgba(234,88,12,0.07)',

  text:  '#1e293b',
  textS: '#64748b',
  textM: '#94a3b8',

  chartBg:   '#ffffff',
  buyCandle: '#2563eb',
  selCandle: '#dc2626',
  marklineBuy:  '#2563eb',
  marklineSell: '#dc2626',
  marklineOpen: '#888888',
  marklineSL:   '#E55604',
  marklineTP:   '#9333ea',
  axisLabel:    '#64748b',
  splitLine:    '#e5e7eb',
  lineChart:    '#2563eb',
  lineChartA1:  'rgba(37,99,235,0.12)',
  lineChartA2:  'rgba(37,99,235,0)',

  sans: "'DM Sans','Segoe UI',sans-serif",
  mono: "'JetBrains Mono','Fira Code','Consolas',monospace",
};

export function ThemeProvider({ children }) {
  return <>{children}</>;
}

export function useTheme() {
  const isDark = useSelector(selectIsDark);
  return isDark ? darkTheme : lightTheme;
}

export function useThemeMode() {
  const isDark = useSelector(selectIsDark);
  const dispatch = useDispatch();
  const toggleTheme = () => dispatch(toggleThemeAction());
  return { isDark, toggleTheme };
}
